import React from 'react'
import Snackbar from '@material-ui/core/Snackbar'
import MuiAlert from '@material-ui/lab/Alert'
import { makeStyles } from '@material-ui/core/styles'
import { useDispatch } from 'react-redux'
import { closeSnackbar } from 'store/actions'
import ReactDOM from 'react-dom'
function Alert(props) {
	return <MuiAlert elevation={6} variant="filled" {...props} />
}

const useStyles = makeStyles(theme => ({
	root: {
		width: '100%',
		'& > * + *': {
			marginTop: theme.spacing(2),
		},
	},
}))

function SnackbarComponent({ runSnackBar, content, severity, ...props }) {
	const dispacth = useDispatch()

	const classes = useStyles()
	const [openTime, setOpenTime] = React.useState(false)
	// const [open, setOpen] = React.useState(false)
	React.useEffect(() => {
		if (runSnackBar) {
			setOpenTime(5000)
		}
	}, [runSnackBar])
	const handleClose = (event, reason) => {
		if (reason === 'clickaway') {
			return
		}
		dispacth(closeSnackbar(false))
	}
	return ReactDOM.createPortal(
		<div className={classes.root}>
			<Snackbar
				open={runSnackBar}
				autoHideDuration={openTime}
				onClose={handleClose}
				anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
			>
				<Alert onClose={handleClose} severity={severity}>
					{content}
				</Alert>
			</Snackbar>
		</div>,
		document.body,
	)
	return (
		<div className={classes.root}>
			<Snackbar
				open={runSnackBar}
				autoHideDuration={openTime}
				onClose={handleClose}
				anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
			>
				<Alert onClose={handleClose} severity={severity}>
					{content}
				</Alert>
			</Snackbar>
		</div>
	)
}
export default SnackbarComponent
